import React, { useRef, useState } from "react";
import {
    I2cIcon,
    I2cRadioGroup,
    I2cRadioButton,
    I2cPhoneField,
    I2cTextarea,
    I2cInput, I2cButton, I2cFileUpload
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../../../PrepaidComponents/Prepaid.scss";
import { Controller } from "react-hook-form";
import ErrorMessage from "../../../../Components/SharedComponent/ErrorMessage/ErrorMessage";



const IOSApplicationGuidelines = ({ control, handleValueChanges, methods, errors, getFileRef, handleFileUpload, fileJson }) => {

    return (
        <>
            <div i2c-grid="12 12@md">
                <div className="sub-heading">
                    iOS App Publishing Guideline
                </div>
            </div>
            <div i2c-grid="12 12@md">
                <div className="custom-label mb-1-5">
                    App Icon
                </div>
                <Controller
                    name="brand_info_mob_app_ios_icon_file"
                    control={control}
                    render={({ field }) => (
                        <I2cFileUpload
                            ref={getFileRef("brand_info_mob_app_ios_icon_file")}
                            max-file-size="0.09814697265625"
                            autoProcessQueue={false}
                            no-mobile-controls
                            max-files={1}
                            className="customFileUpload"
                            setAcceptedFiles=".svg, .ai, .pdf, esp"
                            icon="linear-document-upload"
                            label="Click to upload"
                            caption="or drag and drop"
                            name="brand_info_mob_app_ios_icon_file"
                            message="Format: SVG, AI, PDF or ESP Format | Dimensions: max. 800x400px"
                            onI2cFileRemoved={(e) => {
                                if (
                                    fileJson?.brand_info_mob_app_ios_icon_file?.length
                                )
                                    methods.setValue(
                                        "brand_info_mob_app_ios_icon_file",
                                        fileJson?.brand_info_mob_app_ios_icon_file,
                                    );
                                else methods.setValue("brand_info_mob_app_ios_icon_file", "");
                                methods.trigger();
                                handleValueChanges();
                            }}
                            onI2cAddedFile={(e) => {
                                const fileRef = getFileRef("brand_info_mob_app_ios_icon_file");
                                handleFileUpload(
                                    fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                    "brand_info_mob_app_ios_icon_file"
                                );
                            }}
                        />
                    )}
                />
            </div>
            <div i2c-grid="12 12@md">
                <>
                    <div className="single-field-wrapper">
                        <Controller
                            name="brand_info_mob_app_ios_app_name"
                            control={control}
                            render={({ field }) => (
                                <I2cInput
                                    {...field}
                                    className="single-input-field"
                                    placeholder="App Name"
                                    required
                                    onI2cInput={(e) => {
                                        const value = e.target.value;
                                        field.onChange(value);
                                        handleValueChanges();
                                    }}
                                    size="large"
                                    name={"brand_info_mob_app_ios_app_name"}
                                >
                                    <I2cIcon slot="suffix" name="cs-linear-help-circle"></I2cIcon>
                                    <span slot="label" className="organize-tooltip">
                                        <span className="custom-label">
                                            {" "}
                                            App Name
                                        </span>
                                    </span>
                                </I2cInput>
                            )}
                        />
                    </div>
                </>
            </div>
            <div i2c-grid="12 12@md">
                <div className="single-field-wrapper">
                    <Controller
                        name="brand_info_mob_app_ios_description_for_app_store"
                        control={control}
                        render={({ field }) => (
                            <I2cTextarea
                                label="Specify the description for App Store."
                                {...field}
                                name="brand_info_mob_app_ios_description_for_app_store"
                                resize="none"
                                onI2cInput={(e) => {
                                    const value = e.target.value;
                                    field.onChange(value);
                                    methods.trigger();
                                    handleValueChanges();
                                }}
                                placeholder="Enter description"
                                rows={5}
                            />
                        )}
                    />
                    <ErrorMessage
                        show={
                            errors.brand_info_mob_app_ios_description_for_app_store &&
                                methods.formState.touchedFields.brand_info_mob_app_ios_description_for_app_store
                                ? true
                                : false
                        }
                        message={errors.brand_info_mob_app_ios_description_for_app_store?.message ?? "Invalid input"}
                    />
                </div>
            </div>
            <div i2c-grid="12 12@md">
                <div className="single-field-wrapper">
                    <Controller
                        name="brand_info_mob_app_ios_keywords"
                        control={control}
                        render={({ field }) => (
                            <I2cTextarea
                                label="Specify keywords."
                                {...field}
                                name="brand_info_mob_app_ios_keywords"
                                resize="none"
                                onI2cInput={(e) => {
                                    const value = e.target.value;
                                    field.onChange(value);
                                    methods.trigger();
                                    handleValueChanges();
                                }}
                                placeholder="Enter keywords"
                                rows={5}
                            />
                        )}
                    />
                    <ErrorMessage
                        show={
                            errors.brand_info_mob_app_ios_keywords &&
                                methods.formState.touchedFields.brand_info_mob_app_ios_keywords
                                ? true
                                : false
                        }
                        message={errors.brand_info_mob_app_ios_keywords?.message ?? "Invalid input"}
                    />
                </div>
            </div>
            <div i2c-grid="12 12@md">
                <div className="single-field-wrapper">
                    <Controller
                        name="brand_info_mob_app_ios_support_url"
                        control={control}
                        render={({ field }) => (
                            <I2cInput
                                {...field}
                                className="single-input-field"
                                placeholder="www.i2cinc.com"
                                required
                                onI2cInput={(e) => {
                                    const value = e.target.value;
                                    field.onChange(value);
                                    handleValueChanges();
                                }}
                                size="large"
                                name={"brand_info_mob_app_ios_support_url"}
                                prefix_label="http://"
                            >
                                <span slot="label" className="organize-tooltip">
                                    <span className="custom-label">
                                        {" "}
                                        Support URL
                                    </span>
                                </span>
                                <I2cIcon slot="suffix" name="cs-linear-help-circle"></I2cIcon>
                            </I2cInput>
                        )}
                    />
                </div>
            </div>
            <div i2c-grid="12 12@md">
                <div className="custom-label mb-1-5">
                    Provide 4 to 5 modules/features to display on the App Store.
                </div>
                <Controller
                    name="brand_info_mob_app_ios_module_features_file"
                    control={control}
                    render={({ field }) => (
                        <I2cFileUpload
                            ref={getFileRef("brand_info_mob_app_ios_module_features_file")}
                            max-file-size="0.09814697265625"
                            autoProcessQueue={false}
                            no-mobile-controls
                            className="customFileUpload"
                            setAcceptedFiles=".svg, .ai, .pdf, esp"
                            icon="linear-document-upload"
                            label="Click to upload"
                            caption="or drag and drop"
                            name="brand_info_mob_app_ios_module_features_file"
                            message="Format: SVG, AI, PDF or ESP Format | Dimensions: max. 800x400px"
                            onI2cFileRemoved={(e) => {
                                if (
                                    fileJson?.brand_info_mob_app_ios_module_features_file?.length
                                )
                                    methods.setValue(
                                        "brand_info_mob_app_ios_module_features_file",
                                        fileJson?.brand_info_mob_app_ios_module_features_file,
                                    );
                                else methods.setValue("brand_info_mob_app_ios_module_features_file", "");
                                methods.trigger();
                                handleValueChanges();
                            }}
                            onI2cAddedFile={(e) => {
                                const fileRef = getFileRef("brand_info_mob_app_ios_module_features_file");
                                handleFileUpload(
                                    fileRef.current.getDropZone().files[fileRef.current.getDropZone().files.length - 1],
                                    "brand_info_mob_app_ios_module_features_file"
                                );
                            }}
                        />
                    )}
                />
            </div>
        </>
    );
};

export default IOSApplicationGuidelines;
